import * as React from 'react';

var _circle, _path, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgClock = function SvgClock(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 44,
        cy: 44,
        r: 30,
        fill: "url(#paint0_linear_19_411)",
        fillOpacity: 0.16
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_19_411)",
        d: "M51.846 53.801q.339.366.871.366t.996-.463q.435-.435.444-.973.01-.54-.44-.968L41.405 39.449V24.026q0-.488-.358-.843-.359-.357-.926-.356-.57 0-.924.357-.357.358-.356.925v15.506q0 .472.166.871.167.399.5.751zM40.011 70q-6.203 0-11.65-2.362-5.445-2.361-9.54-6.451-4.093-4.09-6.457-9.531T10 40.01q0-6.203 2.362-11.65 2.361-5.445 6.451-9.54 4.09-4.093 9.532-6.457Q33.785 10 39.989 10t11.65 2.362 9.54 6.451q4.093 4.09 6.457 9.532Q70 33.785 70 39.989t-2.362 11.65-6.451 9.54q-4.09 4.093-9.531 6.457T40.01 70M40 67.436q11.346 0 19.391-8.045T67.436 40 59.39 20.609 40 12.564 20.609 20.61 12.564 40t8.045 19.391T40 67.436"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_19_411",
        x1: 14.627,
        x2: 73.165,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_19_411",
        x1: 10.627,
        x2: 69.165,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgClock as ReactComponent };
//# sourceMappingURL=Clock.svg.es.js.map
